import { Actions, Intersection, TriggerType } from './types'
import { ScreenInManager } from './ScreenInManager/ScreenInManager'

export default function init({ model, manager }: { model: Actions; manager: ScreenInManager }) {
	const SCREEN_IN_ACTION = 'screenIn'
	const HIGHER_THAN_VIEWPORT_THRESHOLD = 0.01

	let observers: any = {}

	/**
	 * Get screen in threshold from animation definition
	 * @param animationManager
	 * @param animationDefs
	 * @param id
	 * @returns {*}
	 */
	function getAnimationThreshold(screeInManager: ScreenInManager, animationDefs: Actions, id: string) {
		const animationName = animationDefs[id][0].name
		return screeInManager.getAnimationProperties(animationName).viewportThreshold
	}

	/**
	 * build an intersection observer
	 * @param callback
	 * @param threshold
	 * @returns {IntersectionObserver}
	 */
	function getObserver(callback: Function, threshold: number) {
		const options = {
			root: null, // document
			rootMargin: '0px',
			threshold: [threshold],
		}

		function handler(entries: any, observer: any) {
			const intersections = entries.map((entry: any) => ({
				visible: entry.isIntersecting,
				ratio: entry.intersectionRatio,
				rect: entry.intersectionRect,
				id: entry.target.id,
			}))

			entries.forEach((entry: any) => entry.isIntersecting && observer.unobserve(entry.target))

			callback(intersections)
		}

		return new window.IntersectionObserver(handler, options)
	}

	/**
	 * trigger animation when element is visible
	 * @param intersections
	 */
	function intersectionHandler(intersections: Array<Intersection>) {
		const idsToTrigger: Array<TriggerType> = intersections
			.filter((inter: any) => inter.visible)
			.map((inter: any) => ({
				compId: inter.id,
				action: SCREEN_IN_ACTION,
			}))

		manager.trigger(idsToTrigger)
	}

	/**
	 * Observe elements and save to observers array
	 * @param el
	 * @param threshold
	 */
	function observeElement(el: HTMLElement, threshold: number) {
		const observer = observers[threshold] || getObserver(intersectionHandler, threshold)
		observer.observe(el)

		if (!observers[threshold]) {
			observers[threshold] = observer
		}
	}

	/**
	 * Run on the list of animation defs and connect elements to intersection observer events
	 */
	function traverseModel() {
		const screenHeight = window.innerHeight
		Object.keys(model).forEach((id) => {
			const el = document.getElementById(id)
			if (el) {
				const height = el.offsetHeight
				const threshold =
					height > screenHeight ? HIGHER_THAN_VIEWPORT_THRESHOLD : getAnimationThreshold(manager, model, id)
				observeElement(el, threshold)
			}
		})
	}

	/**
	 * disconnect all observers and clear observers array
	 */
	function disconnectObserver() {
		Object.keys(observers).forEach((key) => observers[key].disconnect())
		observers = {}
	}

	return {
		start: traverseModel,
		stop: disconnectObserver,
	}
}
